import { Drawer } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { MeetingContent } from "./MeetingContent"
import { fetchOrderDetails, OrderDetailsResponse, ServiceCenterMeetingQuery } from "../../meetings/meetingApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { useEffect } from "react"
import { ServiceCenterBooking } from "../../serviceCenterHomeTypes"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "2rem",
        background: theme.palette.common.white,
    },
    drawer: {
        scrollbarWidth: "none",
        width: "45%",
    },
    backdrop: {
        backgroundColor: "transparent",
    },
}))

const transformData = (data: OrderDetailsResponse) => data.order

export function MeetingDrawer({
    isOpen,
    onClose,
    meetings,
    orderId,
}: {
    isOpen: boolean
    onClose: () => void
    meetings?: ServiceCenterBooking[]
    orderId?: number
}) {
    const { classes } = useStyles()

    const {
        data: orderDetails,
        isLoading,
        isError,
    } = useApiQuery(fetchOrderDetails, {
        queryName: ServiceCenterMeetingQuery.SERVICE_CENTER_MEETING_DETAILS,
        dependencies: {
            orderId: orderId ?? 0,
        },
        enabled: isOpen && Boolean(orderId),
        select: transformData,
        forceMock: true,
    })

    // as receipt need order with uid to get selected item
    const mappedMeetings = meetings?.map((m) => ({ ...m, uid: String(m.id) }))

    useEffect(() => {
        if (isError) {
            onClose()
        }
    }, [isError])

    return (
        <Drawer
            anchor="right"
            variant="persistent"
            open={isOpen}
            onClose={onClose}
            classes={{ paper: classes.drawer }}
            ModalProps={{
                BackdropProps: {
                    classes: { root: classes.backdrop },
                },
            }}
        >
            <MeetingContent
                isLoading={isLoading}
                onClose={onClose}
                meetings={mappedMeetings}
                orderId={orderId}
                meetingData={orderDetails}
            />
        </Drawer>
    )
}
